/* =========================================================
   BASEUS — Collection Page JS  (bs-collection-page.js)
   Handles: sidebar filters, grid/list toggle, price slider,
            rating filter, sort, chips, AJAX add-to-cart
   ========================================================= */
(function () {
  'use strict';

  var LS_VIEW = 'bsc_view';
  var LS_COLS = 'bsc_cols';

  /* ── Helpers ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ── State ── */
  var state = {
    view:        localStorage.getItem(LS_VIEW) || 'grid',
    cols:        parseInt(localStorage.getItem(LS_COLS), 10) || 3,
    priceMax:    Infinity,
    minRating:   0,
    onlyDiscount: false,
    onlyInStock:  false,
  };

  /* ── DOM refs ── */
  var grid      = $('#bsc-grid');
  var listView  = $('#bsc-list');
  var colToggle = $('#bsc-col-toggle');
  var countEl   = $('#bsc-count');
  var chipsEl   = $('#bsc-chips');
  var emptyEl   = $('#bsc-empty');
  var priceSlider  = $('#bsc-price-slider');
  var priceMaxLabel = $('#bsc-price-max-label');
  var sortSelect   = $('#bsc-sort-select');

  /* ── Init view ── */
  function applyView() {
    var isGrid = state.view === 'grid';
    if (grid)     grid.style.display     = isGrid ? '' : 'none';
    if (listView) listView.style.display = isGrid ? 'none' : '';
    $$('.bsc-view-btn').forEach(function (btn) {
      btn.classList.toggle('bsc-view-btn--active', btn.dataset.view === state.view);
    });
    if (colToggle) colToggle.style.display = isGrid ? '' : 'none';
  }

  function applyColumns() {
    if (grid) grid.dataset.cols = state.cols;
    $$('.bsc-col-btn').forEach(function (btn) {
      btn.classList.toggle('bsc-col-btn--active', parseInt(btn.dataset.cols, 10) === state.cols);
    });
  }

  /* ── Filtering ── */
  function getCards() {
    return $$('[data-product-price]', grid || document);
  }

  function getListCards() {
    return $$('[data-product-price]', listView || document);
  }

  function filterProducts() {
    var visibleGrid = 0;
    var visibleList = 0;

    function processCard(card, countRef) {
      var price     = parseInt(card.dataset.productPrice, 10) || 0;
      var compare   = parseInt(card.dataset.productCompare, 10) || 0;
      var available = card.dataset.productAvailable === 'true';
      var rating    = parseFloat(card.dataset.productRating) || 5;

      var show = true;
      if (price > state.priceMax)                        show = false;
      if (state.minRating > 0 && rating < state.minRating) show = false;
      if (state.onlyDiscount && compare <= price)        show = false;
      if (state.onlyInStock && !available)               show = false;

      card.classList.toggle('bsc-card--hidden',      !show);
      card.classList.toggle('bsc-list-card--hidden', !show);
      if (show) countRef.count++;
    }

    var gc = { count: 0 };
    getCards().forEach(function (c) { processCard(c, gc); });
    visibleGrid = gc.count;

    var lc = { count: 0 };
    getListCards().forEach(function (c) { processCard(c, lc); });
    visibleList = lc.count;

    var visible = state.view === 'grid' ? visibleGrid : visibleList;
    if (countEl) countEl.textContent = visible;
    if (emptyEl) emptyEl.classList.toggle('bsc-empty--visible', visible === 0);
  }

  /* ── Chips ── */
  function renderChips() {
    if (!chipsEl) return;
    chipsEl.innerHTML = '';
    var chips = [];

    if (state.priceMax < 10000000) {
      chips.push({ label: 'Max ₺' + Math.round(state.priceMax / 100), key: 'priceMax' });
    }
    if (state.minRating > 0) {
      chips.push({ label: state.minRating + '+ Puan', key: 'minRating' });
    }
    if (state.onlyDiscount) {
      chips.push({ label: 'İndirimli', key: 'onlyDiscount' });
    }
    if (state.onlyInStock) {
      chips.push({ label: 'Stokta', key: 'onlyInStock' });
    }

    chips.forEach(function (chip) {
      var el = document.createElement('div');
      el.className = 'bsc-chip';
      el.innerHTML =
        chip.label +
        '<button class="bsc-chip__remove" aria-label="Kaldır">' +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none">' +
        '<path d="M9 3L3 9M3 3l6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg></button>';
      el.querySelector('.bsc-chip__remove').addEventListener('click', function () {
        if (chip.key === 'priceMax')     { state.priceMax = Infinity; if (priceSlider) { priceSlider.value = priceSlider.max; updateSliderUI(); } }
        if (chip.key === 'minRating')    { state.minRating = 0;    setRatingActive(0); }
        if (chip.key === 'onlyDiscount') { state.onlyDiscount = false; updateCheckboxUI(); }
        if (chip.key === 'onlyInStock')  { state.onlyInStock  = false; updateCheckboxUI(); }
        renderChips();
        filterProducts();
      });
      chipsEl.appendChild(el);
    });
  }

  /* ── Price slider ── */
  function updateSliderUI() {
    if (!priceSlider) return;
    var val = parseInt(priceSlider.value, 10);
    var min = parseInt(priceSlider.min, 10) || 0;
    var max = parseInt(priceSlider.max, 10) || 200000;
    var pct = ((val - min) / (max - min) * 100).toFixed(1) + '%';
    priceSlider.style.setProperty('--pct', pct);
    if (priceMaxLabel) priceMaxLabel.textContent = '₺' + Math.round(val / 100);
  }

  if (priceSlider) {
    priceSlider.addEventListener('input', function () {
      state.priceMax = parseInt(this.value, 10);
      updateSliderUI();
      filterProducts();
      renderChips();
    });
    updateSliderUI();
    state.priceMax = Infinity; // start with no filter
  }

  /* ── Rating buttons ── */
  function setRatingActive(val) {
    $$('.bsc-rating-btn').forEach(function (btn) {
      btn.classList.toggle('bsc-rating-btn--active', parseFloat(btn.dataset.rating) === val);
    });
  }

  $$('.bsc-rating-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseFloat(this.dataset.rating) || 0;
      state.minRating = val;
      setRatingActive(val);
      filterProducts();
      renderChips();
    });
  });

  /* ── Checkbox filters ── */
  function updateCheckboxUI() {
    var discountBox = $('#bsc-check-discount');
    var stockBox    = $('#bsc-check-stock');
    if (discountBox) discountBox.classList.toggle('bsc-checkbox--checked', state.onlyDiscount);
    if (stockBox)    stockBox.classList.toggle('bsc-checkbox--checked',    state.onlyInStock);
  }

  var discountRow = $('#bsc-row-discount');
  var stockRow    = $('#bsc-row-stock');

  if (discountRow) {
    discountRow.addEventListener('click', function () {
      state.onlyDiscount = !state.onlyDiscount;
      updateCheckboxUI();
      filterProducts();
      renderChips();
    });
  }
  if (stockRow) {
    stockRow.addEventListener('click', function () {
      state.onlyInStock = !state.onlyInStock;
      updateCheckboxUI();
      filterProducts();
      renderChips();
    });
  }

  /* ── View toggle ── */
  $$('.bsc-view-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.view = this.dataset.view;
      localStorage.setItem(LS_VIEW, state.view);
      applyView();
      filterProducts();
    });
  });

  /* ── Column toggle ── */
  $$('.bsc-col-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.cols = parseInt(this.dataset.cols, 10);
      localStorage.setItem(LS_COLS, state.cols);
      applyColumns();
    });
  });

  /* ── Sort (triggers page navigation) ── */
  if (sortSelect) {
    var DEFAULT_SORT = 'created-descending';
    var legacySortMap = {
      popular: 'best-selling',
      rating: DEFAULT_SORT,
      manual: DEFAULT_SORT,
      new: 'created-descending',
      price_asc: 'price-ascending',
      price_desc: 'price-descending'
    };
    var validSorts = {
      'best-selling': true,
      'created-descending': true,
      'created-ascending': true,
      'price-ascending': true,
      'price-descending': true
    };
    var normalizeSort = function (value) {
      var normalized = legacySortMap[value] || value || DEFAULT_SORT;
      return validSorts[normalized] ? normalized : DEFAULT_SORT;
    };
    var params = new URLSearchParams(window.location.search);
    var rawSort = params.get('sort_by');
    var currentSort = normalizeSort(rawSort);

    if (rawSort !== currentSort) {
      var initialUrl = new URL(window.location.href);
      initialUrl.searchParams.set('sort_by', currentSort);
      initialUrl.searchParams.delete('page');
      window.location.replace(initialUrl.toString());
      return;
    }

    sortSelect.value = currentSort;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', normalizeSort(this.value));
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ── Sidebar section collapse ── */
  $$('.bsc-filter-section__header').forEach(function (header) {
    header.addEventListener('click', function () {
      var body = this.nextElementSibling;
      var chevron = this.querySelector('.bsc-filter-chevron');
      if (!body) return;
      var open = !body.classList.contains('bsc-filter-body--hidden');
      body.classList.toggle('bsc-filter-body--hidden', open);
      if (chevron) chevron.classList.toggle('bsc-filter-chevron--open', !open);
      this.classList.toggle('bsc-filter-section__header--closed', open);
    });
    // Init chevron open state
    var body = header.nextElementSibling;
    var chevron = header.querySelector('.bsc-filter-chevron');
    if (body && !body.classList.contains('bsc-filter-body--hidden') && chevron) {
      chevron.classList.add('bsc-filter-chevron--open');
    }
  });

  /* ── Clear all filters ── */
  var clearBtn = $('#bsc-clear-filters');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      state.priceMax    = Infinity;
      state.minRating   = 0;
      state.onlyDiscount = false;
      state.onlyInStock  = false;
      if (priceSlider) { priceSlider.value = priceSlider.max; updateSliderUI(); }
      setRatingActive(0);
      updateCheckboxUI();
      filterProducts();
      renderChips();
    });
  }

  /* ── AJAX Add to Cart ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bsc-add-btn, .bsc-list-card__add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    var original = btn.textContent;

    // Collect cart-items-component section IDs for theme re-render
    var cartSectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      cartSectionIds.push(el.dataset.sectionId);
    });

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cartSectionIds.length) formData.append('sections', cartSectionIds.join(','));

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Accept': 'application/json' },
      body:    formData
    })
      .then(function (r) { return r.json(); })
      .then(function (cartResponse) {
        btn.classList.add('bsc-add-btn--added', 'bsc-list-card__add--added');
        btn.textContent = '✓ Eklendi';

        // Dispatch the event the theme's cart drawer / cart-items-component listens for
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartResponse,
            sourceId: variantId,
            data: {
              sections: cartResponse.sections || {}
            }
          }
        }));

        setTimeout(function () {
          btn.classList.remove('bsc-add-btn--added', 'bsc-list-card__add--added');
          btn.textContent = original;
          btn.disabled    = false;
        }, 1800);
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  /* ── Wishlist toggle ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bsc-card__wishlist');
    if (!btn) return;
    e.preventDefault();
    btn.classList.toggle('bsc-card__wishlist--active');
    btn.style.color = btn.classList.contains('bsc-card__wishlist--active') ? '#f5c800' : '';
    btn.style.borderColor = btn.classList.contains('bsc-card__wishlist--active') ? '#f5c800' : '';
  });

  /* ── Init ── */
  applyView();
  applyColumns();
  filterProducts();

})();
